<script lang="ts">
    import type { JobHistoryItem } from './JobHistoryItem';
    import { _ } from 'svelte-i18n';
    import { debug } from '../../../../stores/store';
    import type { JobHistoryApp } from './JobHistoryApp';
    import Opacity from '../../../shared/Opacity.svelte';
    import IconArrowRightAlt from '../../../shared/Icons/IconArrowRightAlt.svelte';
    import WarningColor from '../../../shared/WarningColor.svelte';

    export let jobHistoryItem: JobHistoryItem;
    export let jobHistoryApp: JobHistoryApp;
    export let showDetails: boolean = false;

    function upperFirstLetter(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
</script>

<div
    style="display: flex; flex-direction: row; align-items: center; column-gap: 5px; justify-content: flex-start;"
>
    {#if jobHistoryItem.getData().event_type === 'create'}
        {$_('New job')}
        <div class="job-history-mark" style="text-transform: lowercase">({$_('to_assign')})</div>
    {:else if jobHistoryItem.getData().event_type === 'confirm'}
        {#if jobHistoryItem.isConfirmRejected()}
            <WarningColor>{$_('Rejected')}</WarningColor>
        {:else}
            {$_('job_history_confirm')}
            <Opacity opacity={0.6}>
                <IconArrowRightAlt scale={0.5} />
            </Opacity>
            {#if jobHistoryItem.getNewVehicleId() !== null || showDetails}
                {jobHistoryItem.getNewVehicleName() ?? $_('undefined')}
            {/if}
            {#if jobHistoryItem.getNewProcessStatusName() !== null && jobHistoryItem.getNewProcessStatusId() > 0}
                <div class="job-history-mark" style="text-transform: lowercase">
                    ({$_(jobHistoryItem.getNewProcessStatusName() ?? 'undefined')})
                </div>
            {/if}
        {/if}
    {:else if ['suggest'].includes(jobHistoryItem.getData().event_type)}
        {$_('job_history_suggest')}
        <Opacity opacity={0.6}>
            <IconArrowRightAlt scale={0.5} />
        </Opacity>
        {#if jobHistoryItem.getNewVehicleId() !== null || showDetails}
            {jobHistoryItem.getNewVehicleName() ?? $_('undefined')}
        {/if}
        {#if jobHistoryItem.getNewProcessStatusName() !== null && jobHistoryItem.getNewProcessStatusId() > 0}
            <div class="job-history-mark" style="text-transform: lowercase">
                ({$_(jobHistoryItem.getNewProcessStatusName() ?? 'undefined')})
            </div>
        {/if}
    {:else if ['data_change'].includes(jobHistoryItem.getData().event_type) && jobHistoryItem.isProcessIncreasing() !== null}
        {#if jobHistoryItem.isProcessIncreasing()}
            {#if jobHistoryItem.getNewProcessStatusId() !== null || showDetails}
                {upperFirstLetter($_(jobHistoryItem.getNewProcessStatusDesc() ?? 'undefined'))}
            {/if}
            <Opacity opacity={0.6}>
                <IconArrowRightAlt scale={0.5} />
            </Opacity>
            {#if jobHistoryItem.getNewVehicleId() !== null || showDetails}
                {jobHistoryItem.getNewVehicleName() ?? $_('undefined')}
            {/if}
            {#if jobHistoryItem.getNewProcessStatusId() > 0}
                <div class="job-history-mark" style="text-transform: lowercase">
                    ({$_(jobHistoryItem.getNewProcessStatusName() ?? 'undefined')})
                </div>
            {/if}
        {:else}
            <WarningColor>{$_('job_history_reject')}</WarningColor>
            <Opacity opacity={0.6}>
                <IconArrowRightAlt scale={0.5} />
            </Opacity>
            {#if jobHistoryItem.getNewProcessStatusId() !== null || showDetails}
                <div class="job-history-mark" style="text-transform: lowercase">
                    ({$_(jobHistoryItem.getNewProcessStatusName() ?? 'undefined')})
                </div>
            {/if}
        {/if}
    {:else}
        {jobHistoryItem.getData().event_type}
    {/if}
</div>

<style>
    .job-history-mark {
        font-weight: 600;
        color: #1c5dc7;
    }
    .capitalize-first-letter {
        display: inline-block;
        /*flex: 1 0;*/
        /*width: 1%;*/
    }
    .capitalize-first-letter:first-letter {
        text-transform: uppercase;
    }
</style>
